import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import assetsService from "../../services/rentals/assetsService";
import MediaUploader from "../../components/MediaUploader";

export default function AssetEdit() {
  const { id } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const res = await assetsService.getAsset(id);
        setForm(res);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = { ...form };
      delete payload._id;
      await assetsService.updateAsset(id, payload);
      navigate(`/rentals/assets`);
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Box>Loading…</Box>;
  if (!form) return <Box>Not found</Box>;

  return (
    <Box>
      <FormControl mb={3}>
        <FormLabel>SKU</FormLabel>
        <Input
          value={form.assetCode || ""}
          onChange={(e) => setForm({ ...form, assetCode: e.target.value })}
        />
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Name</FormLabel>
        <Input
          value={form.name || ""}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Short name</FormLabel>
        <Input
          value={form.shortName || ""}
          onChange={(e) => setForm({ ...form, shortName: e.target.value })}
        />
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>MRP</FormLabel>
        <NumberInput
          value={form.mrp || 0}
          onChange={(v) => setForm({ ...form, mrp: Number(v) })}
        >
          <NumberInputField />
        </NumberInput>
      </FormControl>
      <FormControl mb={3}>
        <FormLabel>Cost Price</FormLabel>
        <NumberInput
          value={form.costPrice || form.baseSellingPrice || 0}
          onChange={(v) => setForm({ ...form, costPrice: Number(v) })}
        >
          <NumberInputField />
        </NumberInput>
      </FormControl>

      <FormControl mb={4}>
        <FormLabel>Image</FormLabel>
        <MediaUploader
          value={form.imageUrl}
          onChange={(url) => setForm({ ...form, imageUrl: url })}
        />
      </FormControl>

      <Button colorScheme="teal" onClick={handleSave} isLoading={saving}>
        Save
      </Button>
    </Box>
  );
}
